import { MinLength, MaxLength } from "class-validator";
import {
    validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
    IsDate, Min, Max
} from "class-validator";
import { ValidateIf, IsNotEmpty, IsNumber, IsString, IsEmpty } from "class-validator";


export class Mtrwb {
    @MaxLength(10, { message: 'COMPANY 字串太長' })
    @IsString({ message: 'COMPANY 不是字串型態' })
    COMPANY: string = "";

    @MaxLength(10)
    CREATOR: string = "";

    @MaxLength(10)
    USR_GROUP: string = "";

    @MaxLength(8)
    CREATE_DATE: string = "";

    @MaxLength(10)
    MODIFIER: string = "";

    @MaxLength(8)
    MODI_DATE: string = "";

    @IsNumber()
    @Max(999)
    FLAG: number = 0;


    @IsNotEmpty({ message: '單別 (WB001) 不可空白' })
    @MaxLength(4, { message: '單別 (WB001) 資料太長' })
    WB001: string = 'MT01';            // 單別 4 [DEF:"MT01"]

    @IsNotEmpty({ message: '單號 (WB002) 不可空白' })
    @MaxLength(11, { message: '單號 (WB002) 資料太長' })
    WB002: string = '';            // 單號 11 

    @IsNotEmpty({ message: '反應者代號 (WB003) 不可空白' })
    @MaxLength(10, { message: '反應者代號 (WB003) 資料太長' })
    WB003: string = '';            // 反應者代號 10 客戶代號

    @IsNotEmpty({ message: '單據日期 (WB004) 不可空白' })
    @MaxLength(8, { message: '單據日期 (WB004) 資料太長' })
    WB004: string = '';            // 單據日期 8 

    @IsNotEmpty({ message: '反應者姓名 (WB005) 不可空白' })
    @MaxLength(10, { message: '反應者姓名 (WB005) 資料太長' })
    WB005: string = '';            // 反應者姓名 10 預設登入者中文姓名(SYSUser.UserName)

    @MaxLength(10, { message: '部門 (WB006) 資料太長' })
    WB006: string = '';            // 部門 10 MTR.MC002 FROM MTRMC WHERE MC001='1'

    @MaxLength(6, { message: '類別 (WB007) 資料太長' })
    WB007: string = '';            // 類別 6 MTR.MC002 FROM MTRMC WHERE MC001='4'  (新增/修改/除錯)

    @MaxLength(10, { message: '程式代號 (WB008) 資料太長' })
    WB008: string = '';            // 程式代號 10 

    @IsNotEmpty({ message: '程式名稱 (WB009) 不可空白' })
    @MaxLength(30, { message: '程式名稱 (WB009) 資料太長' })
    WB009: string = '';            // 程式名稱 30 

    WB010: string = '';            // 問題敘述說明 0 V   2000

    WB011: string = '';            // 處理說明 0 V   2000

    @MaxLength(1, { message: '處理順序 (WB012) 資料太長' })
    WB012: string = '2';            // 處理順序 1 [DEF:"2"]  1:最速件  2:速件 3:一般  4:稍緩  5:未確認規格  9:未排定

    @MaxLength(10, { message: '狀態碼 (WB013) 資料太長' })
    WB013: string = '';            // 狀態碼 10 MTR.MC002 FROM MTRMC WHERE MC001='3' (ex:等USER 等程式 等MIS 等主管 等開會 已完工)

    @MaxLength(1, { message: '結案碼 (WB014) 資料太長' })
    WB014: string = 'N';            // 結案碼 1 [DEF:"N"]

    @MaxLength(8, { message: '預計完工日 (WB015) 資料太長' })
    WB015: string = '';            // 預計完工日 8 

    @IsNotEmpty({ message: 'EMAIL (WB016) 不可空白' })
    @MaxLength(80, { message: 'EMAIL (WB016) 資料太長' })
    WB016: string = '';            // EMAIL 80 附件路徑

    @IsNumber()
    WB017: number = 0;            // 實際工時 5.2 

    @IsNumber()
    WB018: number = 0;            // 報價工時 5.2 

    @MaxLength(20, { message: '訂單單號 (WB019) 資料太長' })
    WB019: string = '';            // 訂單單號 20 950515 ADD  銷貨

    @MaxLength(8, { message: '預計開工日 (WB020) 資料太長' })
    WB020: string = '';            // 預計開工日 8 

    @MaxLength(8, { message: '交件日 (WB021) 資料太長' })
    WB021: string = '';            // 交件日 8 

    @MaxLength(8, { message: 'User預計完工日 (WB022) 資料太長' })
    WB022: string = '';            // User預計完工日 8 

    @IsNotEmpty({ message: '序號 (WB023) 不可空白' })
    @MaxLength(4, { message: '序號 (WB023) 資料太長' })
    WB023: string = '0000';            // 序號 4 [DEF:"0000"]

    @IsNotEmpty({ message: '客戶代號 (WB024) 不可空白' })
    @MaxLength(20, { message: '客戶代號 (WB024) 資料太長' })
    WB024: string = '';            // 客戶代號 20 

    @MaxLength(1, { message: '有附件 (WB025) 資料太長' })
    WB025: string = 'N';            // 有附件 1 [DEF:"N"]  old:文管代號

    @MaxLength(1, { message: '已報價 (WB026) 資料太長' })
    WB026: string = 'N';            // 已報價 1 [DEF:"N"]

    @MaxLength(1, { message: '已回簽 (WB027) 資料太長' })
    WB027: string = 'N';            // 已回簽 1 [DEF:"N"]

    @MaxLength(10, { message: '程式人員 (WB028) 資料太長' })
    WB028: string = '';            // 程式人員 10 

    @MaxLength(1, { message: '已交件 (WB029) 資料太長' })
    WB029: string = 'N';            // 已交件 1 [DEF:"N"] ->等MIS 處理說明->NN/NN/NN 已交件.請更新  交件日

    @MaxLength(1, { message: '預留欄位 (WB030) 資料太長' })
    WB030: string = '';            // 預留欄位 1 

    @MaxLength(1, { message: '預留欄位 (WB031) 資料太長' })
    WB031: string = '';            // 預留欄位 1 

    @MaxLength(10, { message: '預留欄位 (WB032) 資料太長' })
    WB032: string = '';            // 預留欄位 10 

    @MaxLength(10, { message: '預留欄位 (WB033) 資料太長' })
    WB033: string = '';            // 預留欄位 10 

    @MaxLength(10, { message: '預留欄位 (WB034) 資料太長' })
    WB034: string = '';            // 預留欄位 10 

    @IsNumber()
    WB035: number = 0;            // 附件數 6 

    WB036: string = '';            // 傑克程式說明 0 

    @MaxLength(255, { message: 'google文件網址 (WB037) 資料太長' })
    WB037: string = '';            // google文件網址 255 


}
